import { PasswordResetRouteState } from "../types/authForms.types";

/**
 * Null-safe parse of `location.state` for `/password-reset`. The legacy
 * `PasswordReset.tsx` reads `location.state.isPasswordResetRequired` directly,
 * which throws when the screen is opened without navigation state (a direct
 * URL open, a refresh, or a bookmarked link). This treats that case as
 * "reset with an existing password", the same screen the legacy "Reset
 * Password" button on Forgot Password links to.
 */
export const parsePasswordResetState = (state: unknown): PasswordResetRouteState => {
  if (!state || typeof state !== "object") {
    return { isPasswordResetRequired: false, email: "" };
  }

  const candidate = state as Partial<PasswordResetRouteState>;
  return {
    isPasswordResetRequired: candidate.isPasswordResetRequired === true,
    email: typeof candidate.email === "string" ? candidate.email : ""
  };
};

export const buildPasswordResetState = (
  isPasswordResetRequired: boolean,
  email: string
): PasswordResetRouteState => ({ isPasswordResetRequired, email });
